'use client'

import React from 'react'
import CountUp from 'react-countup'

const CountUpNumber = ({data}: {data: number}) => {
  return (
    <CountUp start={0} end={data} duration={5} />
  )
}

export default CountUpNumber;
